export const legalCopy = {
  fr: {
    back: '← Retour au site',
    langLabel: 'Langue',
    updated: 'Dernière mise à jour : 8 octobre 2026',
    brandRole: 'Documents légaux',
    legalNav: 'Navigation légale',
    pages: {
      mentions: {
        kicker: 'Informations légales',
        title: 'Mentions légales',
        intro:
          'Ces mentions légales identifient l’éditeur du site alioune-seck.dev, son activité et son hébergement.',
        sections: [
          {
            title: 'Éditeur du site',
            definitions: [
              ['Nom', 'Alioune Badara Seck'],
              ['Forme juridique', 'Entrepreneur individuel'],
              ['SIREN', '995 288 438'],
              ['SIRET', '995 288 438 00014'],
              ['Code APE', '62.01Z - Programmation informatique'],
              ['Adresse', '1 place Guy Ropartz, 29000 Quimper, France'],
              ['Email', 'contact@alioune-seck.dev'],
              ['Téléphone', '07 84 28 23 93'],
              [
                'Activité',
                'Développement d’applications web, frontend/backend, outils métiers, MVP, intégrations API et accompagnement technique.',
              ],
            ],
          },
          {
            title: 'Directeur de la publication',
            paragraphs: ['Le directeur de la publication du site est Alioune Badara Seck.'],
          },
          {
            title: 'Hébergement',
            definitions: [
              ['Hébergeur', 'Vercel Inc.'],
              ['Adresse', '440 N Barranca Avenue #4133, Covina, CA 91723, États-Unis'],
              ['Téléphone', '+1 559 288 7060'],
              ['Site', 'vercel.com'],
            ],
          },
          {
            title: 'Propriété intellectuelle',
            paragraphs: [
              'Les textes, visuels, maquettes, structures, composants, logos, icônes, extraits de code, études de cas et contenus éditoriaux du site sont protégés par le droit d’auteur et la propriété intellectuelle.',
              'Sauf mention contraire, ces éléments sont la propriété exclusive d’Alioune Badara Seck. Toute reproduction, adaptation, diffusion ou exploitation sans autorisation écrite préalable est interdite.',
            ],
          },
          {
            title: 'Responsabilité',
            paragraphs: [
              'Le site présente une activité professionnelle, des références, des offres de services et des moyens de contact. Les informations sont fournies à titre indicatif et peuvent être modifiées à tout moment.',
              'Malgré le soin apporté au contenu, l’éditeur ne peut garantir l’absence totale d’erreurs, d’omissions ou d’indisponibilités ponctuelles.',
            ],
          },
          {
            title: 'Liens externes',
            paragraphs: [
              'Le site peut contenir des liens vers des sites tiers. L’éditeur ne peut être tenu responsable de leur contenu, de leur politique de confidentialité ou de leur fonctionnement.',
            ],
          },
          {
            title: 'Données personnelles',
            paragraphs: [
              'Les informations transmises via le formulaire de contact sont traitées uniquement dans le cadre des échanges professionnels. La politique de confidentialité détaille les données collectées, leur utilisation et vos droits.',
            ],
          },
          {
            title: 'Droit applicable',
            paragraphs: [
              'Le site est soumis au droit français. En cas de litige et à défaut de résolution amiable, les juridictions françaises compétentes pourront être saisies.',
            ],
          },
        ],
        links: [
          { to: '/cgu', label: 'Consulter les CGU' },
          { to: '/politique-confidentialite', label: 'Politique de confidentialité' },
        ],
      },
      privacy: {
        kicker: 'Données personnelles',
        title: 'Politique de confidentialité',
        intro:
          'Cette politique explique quelles données peuvent être collectées sur le site, pourquoi elles le sont, combien de temps elles sont conservées et quels sont vos droits.',
        sections: [
          {
            title: '1. Responsable du traitement',
            paragraphs: [
              'Le responsable du traitement des données est Alioune Badara Seck, entrepreneur individuel, joignable à contact@alioune-seck.dev.',
            ],
          },
          {
            title: '2. Données collectées',
            paragraphs: ['Lorsque vous utilisez le formulaire de contact, les données suivantes peuvent être collectées :'],
            list: [
              'votre nom ;',
              'votre adresse email ;',
              'le contenu de votre message ;',
              'des données techniques minimales liées à l’envoi du formulaire et à la sécurité du site.',
            ],
            after: [
              'Les réponses saisies dans l’estimateur de projet sont utilisées pour calculer le résultat dans votre navigateur. Elles ne sont pas envoyées comme une demande commerciale tant que vous ne choisissez pas de contacter Alioune Seck et n’envoyez pas le formulaire.',
              'Le site n’a pas vocation à collecter des données sensibles. Merci de ne pas transmettre d’informations confidentielles non nécessaires.',
            ],
          },
          {
            title: '3. Finalités du traitement',
            paragraphs: ['Les données collectées sont utilisées uniquement pour :'],
            list: [
              'répondre à une prise de contact ou à une demande de devis ;',
              'échanger dans un cadre commercial ou précontractuel ;',
              'assurer le suivi des demandes reçues ;',
              'sécuriser le site et limiter les envois abusifs ;',
              'mesurer l’audience, les sources de trafic et les étapes de conversion lorsque vous avez accepté les traceurs de mesure.',
            ],
          },
          {
            title: '4. Base légale',
            list: [
              'l’exécution de mesures précontractuelles lorsque vous sollicitez une réponse, un échange ou une proposition commerciale ;',
              'l’intérêt légitime du responsable de traitement pour gérer les demandes entrantes, protéger le site et organiser son activité ;',
              'votre consentement pour les traceurs de mesure d’audience non strictement nécessaires. Ce consentement peut être retiré à tout moment depuis « Gérer les cookies ».',
            ],
          },
          {
            title: '5. Destinataires des données',
            paragraphs: [
              'Les données ne sont pas vendues ni cédées à des tiers à des fins publicitaires.',
              'Elles peuvent être traitées par les prestataires techniques nécessaires au fonctionnement du site.',
            ],
            list: [
              'l’hébergeur du site ;',
              'le service d’envoi du formulaire de contact ;',
              'la messagerie utilisée pour recevoir et traiter les demandes ;',
              'Google Analytics, uniquement après consentement, pour la mesure d’audience et des conversions.',
            ],
          },
          {
            title: '6. Durée de conservation',
            paragraphs: [
              'Les messages reçus via le formulaire sont conservés pendant une durée raisonnable, limitée à ce qui est nécessaire pour traiter la demande et assurer le suivi commercial.',
            ],
            list: [
              'demandes sans suite contractuelle : conservation maximale de 3 ans à compter du dernier échange ;',
              'éléments liés à une relation commerciale ou contractuelle : conservation pendant la durée utile au dossier, puis archivage si la loi l’impose.',
            ],
          },
          {
            title: '7. Cookies et traceurs',
            paragraphs: [
              'Le site utilise uniquement les traceurs strictement nécessaires sans consentement préalable. Lorsqu’un outil de mesure d’audience non exempté, notamment Google Analytics, est activé, il n’est chargé qu’après votre accord.',
              'Le choix relatif aux traceurs de mesure d’audience est mémorisé localement afin de ne pas redemander votre préférence à chaque page. Vous pouvez modifier ce choix depuis le lien de gestion des cookies présent sur le site.',
              'Les données de mesure d’audience servent à comprendre les pages consultées, les sources de trafic et les étapes de conversion afin d’améliorer le site. Elles ne sont pas utilisées par Alioune Seck pour constituer un profil publicitaire individuel.',
              'Google Analytics est configuré sans Google Signals ni personnalisation publicitaire. Certaines données peuvent être traitées hors de l’Espace économique européen selon les mécanismes de protection mis en œuvre par le prestataire.',
            ],
          },
          {
            title: '8. Sécurité',
            paragraphs: [
              'Des mesures raisonnables sont prises pour protéger les données contre l’accès non autorisé, la perte, l’altération ou la divulgation non souhaitée. Aucun service en ligne ne peut toutefois garantir une sécurité absolue.',
            ],
          },
          {
            title: '9. Vos droits',
            paragraphs: ['Conformément à la réglementation applicable, vous disposez notamment des droits suivants :'],
            list: [
              'droit d’accès ;',
              'droit de rectification ;',
              'droit d’effacement ;',
              'droit d’opposition ;',
              'droit à la limitation du traitement ;',
              'droit de définir des directives relatives au sort de vos données après votre décès.',
            ],
            after: [
              'Vous pouvez exercer vos droits en écrivant à contact@alioune-seck.dev. En cas de difficulté non résolue, vous pouvez introduire une réclamation auprès de la CNIL.',
            ],
          },
          {
            title: '10. Modification de la politique',
            paragraphs: [
              'Cette politique peut être mise à jour pour tenir compte d’une évolution légale, technique ou organisationnelle. La date de dernière mise à jour figure en haut de page.',
            ],
          },
        ],
        links: [
          { to: '/mentions-legales', label: 'Mentions légales' },
          { to: '/cgu', label: 'CGU' },
        ],
      },
      cgu: {
        kicker: 'Conditions d’utilisation',
        title: 'Conditions générales d’utilisation',
        intro:
          'Ces conditions définissent les règles applicables à la navigation sur le site alioune-seck.dev.',
        sections: [
          {
            title: '1. Objet du site',
            paragraphs: [
              'Le site présente l’activité professionnelle d’Alioune Badara Seck, développeur web indépendant, ainsi que ses services, références, réalisations, contenus de présentation et moyens de contact.',
            ],
          },
          {
            title: '2. Acceptation des conditions',
            paragraphs: [
              'En naviguant sur le site, l’utilisateur reconnaît avoir pris connaissance des présentes conditions et les accepter sans réserve.',
            ],
          },
          {
            title: '3. Accès au site',
            paragraphs: [
              'Le site est accessible en principe 24h/24 et 7j/7, sauf interruption programmée ou non, notamment pour maintenance, mise à jour, incident technique ou cas de force majeure.',
              'L’éditeur ne saurait être tenu responsable d’une indisponibilité temporaire, d’un dysfonctionnement ou d’une interruption de service.',
            ],
          },
          {
            title: '4. Usage autorisé',
            paragraphs: ['L’utilisateur s’engage à utiliser le site de manière loyale, licite et raisonnable. Sont notamment interdits :'],
            list: [
              'tout usage frauduleux, abusif ou malveillant du formulaire de contact ;',
              'toute tentative d’intrusion, de dégradation ou de perturbation du site ;',
              'toute extraction massive ou automatisée des contenus sans autorisation ;',
              'toute reproduction ou réutilisation illicite des textes, visuels ou éléments de structure.',
            ],
          },
          {
            title: '5. Contenus publiés',
            paragraphs: [
              'Les contenus publiés ont une vocation informative et commerciale. Ils présentent une activité, une méthode de travail, des exemples de projets et des offres de services.',
              'Les démonstrations, références, extraits de code, interfaces et études de cas sont présentés à titre illustratif et ne constituent pas une garantie de résultat identique pour tout projet.',
            ],
          },
          {
            title: '6. Absence de relation contractuelle automatique',
            paragraphs: [
              'Le simple fait de visiter le site, d’envoyer un message ou de demander un échange ne crée pas automatiquement de relation contractuelle.',
              'Toute mission fait l’objet, selon le cas, d’un devis, d’un accord écrit, d’une proposition commerciale, d’un contrat ou d’une validation explicite entre les parties.',
            ],
          },
          {
            title: '7. Estimateur et indications de budget',
            paragraphs: [
              'L’outil « Estimer mon projet » fournit uniquement un ordre de grandeur à partir des réponses sélectionnées. Son résultat est indicatif, non contractuel et ne constitue ni un devis, ni une offre ferme, ni une promesse de délai.',
              'Le prix et le calendrier définitifs dépendent notamment du périmètre réel, de l’existant, des contenus, des intégrations, des contraintes techniques et des validations nécessaires. Seul un devis, une proposition ou un contrat accepté engage les parties.',
            ],
          },
          {
            title: '8. Propriété intellectuelle',
            paragraphs: [
              'Tous les éléments du site relèvent de la propriété intellectuelle de leur auteur ou de leurs ayants droit. Toute reproduction, adaptation, diffusion, publication ou exploitation non autorisée est interdite.',
            ],
          },
          {
            title: '9. Liens externes',
            paragraphs: [
              'Le site peut renvoyer vers des plateformes externes, outils tiers, réseaux sociaux ou services partenaires. L’éditeur n’exerce pas de contrôle permanent sur ces contenus et décline toute responsabilité à leur sujet.',
            ],
          },
          {
            title: '10. Responsabilité',
            paragraphs: [
              'L’éditeur s’efforce de fournir des informations fiables et à jour. Il ne garantit toutefois ni l’exhaustivité absolue, ni l’absence d’erreur, ni l’adéquation du contenu à un besoin particulier.',
              'L’utilisateur reste seul responsable de l’usage qu’il fait des informations consultées sur le site.',
            ],
          },
          {
            title: '11. Données personnelles',
            paragraphs: [
              'L’utilisation du formulaire de contact implique la transmission volontaire de certaines données personnelles. Leur traitement est décrit dans la politique de confidentialité.',
            ],
          },
          {
            title: '12. Modification des CGU',
            paragraphs: [
              'Les présentes conditions peuvent être modifiées à tout moment. La version applicable est celle publiée sur le site à la date de consultation.',
            ],
          },
          {
            title: '13. Droit applicable',
            paragraphs: [
              'Les présentes CGU sont soumises au droit français. En cas de litige et à défaut de résolution amiable, les juridictions françaises compétentes pourront être saisies.',
            ],
          },
        ],
        links: [
          { to: '/mentions-legales', label: 'Mentions légales' },
          { to: '/politique-confidentialite', label: 'Politique de confidentialité' },
        ],
      },
    },
  },
  en: {
    back: '← Back to website',
    langLabel: 'Language',
    updated: 'Last updated: October 8, 2026',
    brandRole: 'Legal documents',
    legalNav: 'Legal navigation',
    pages: {
      mentions: {
        kicker: 'Legal information',
        title: 'Legal notice',
        intro:
          'This notice identifies the publisher of alioune-seck.dev, its activity and hosting provider.',
        sections: [
          {
            title: 'Website publisher',
            definitions: [
              ['Name', 'Alioune Badara Seck'],
              ['Legal form', 'Sole proprietor'],
              ['SIREN', '995 288 438'],
              ['SIRET', '995 288 438 00014'],
              ['APE code', '62.01Z - Computer programming'],
              ['Address', '1 place Guy Ropartz, 29000 Quimper, France'],
              ['Email', 'contact@alioune-seck.dev'],
              ['Phone', '+33 7 84 28 23 93'],
              [
                'Activity',
                'Web application development, frontend/backend development, business tools, MVPs, API integrations and technical support.',
              ],
            ],
          },
          { title: 'Publication director', paragraphs: ['The publication director is Alioune Badara Seck.'] },
          {
            title: 'Hosting',
            definitions: [
              ['Provider', 'Vercel Inc.'],
              ['Address', '440 N Barranca Avenue #4133, Covina, CA 91723, United States'],
              ['Phone', '+1 559 288 7060'],
              ['Website', 'vercel.com'],
            ],
          },
          {
            title: 'Intellectual property',
            paragraphs: [
              'Texts, visuals, layouts, structures, components, logos, icons, code excerpts, case studies and editorial content are protected by copyright and intellectual property law.',
              'Unless stated otherwise, these elements are the exclusive property of Alioune Badara Seck. Any reproduction, adaptation, distribution or use without prior written authorization is prohibited.',
            ],
          },
          {
            title: 'Liability',
            paragraphs: [
              'The website presents a professional activity, references, service offers and contact methods. Information is provided for guidance and may be updated at any time.',
              'Although care is taken when updating the content, the publisher cannot guarantee the complete absence of errors, omissions or occasional unavailability.',
            ],
          },
          {
            title: 'External links',
            paragraphs: [
              'The website may contain links to third-party websites. The publisher is not responsible for their content, privacy policy or operation.',
            ],
          },
          {
            title: 'Personal data',
            paragraphs: [
              'Information sent through the contact form is processed only for professional exchanges. The privacy policy explains collected data, usage and user rights.',
            ],
          },
          {
            title: 'Applicable law',
            paragraphs: [
              'This website is governed by French law. In case of dispute and without amicable resolution, the competent French courts may be seized.',
            ],
          },
        ],
        links: [
          { to: '/cgu', label: 'Terms of use' },
          { to: '/politique-confidentialite', label: 'Privacy policy' },
        ],
      },
      privacy: {
        kicker: 'Personal data',
        title: 'Privacy policy',
        intro:
          'This policy explains what data may be collected, why it is collected, how long it is kept and what your rights are.',
        sections: [
          { title: '1. Data controller', paragraphs: ['The data controller is Alioune Badara Seck, sole proprietor, reachable at contact@alioune-seck.dev.'] },
          {
            title: '2. Data collected',
            paragraphs: ['When you use the contact form, the following data may be collected:'],
            list: ['your name;', 'your email address;', 'the content of your message;', 'minimal technical data linked to form sending and website security.'],
            after: ['The website is not intended to collect sensitive data. Please do not send unnecessary confidential information.'],
          },
          {
            title: '3. Purposes',
            paragraphs: ['Collected data is used only to:'],
            list: ['answer a contact or quote request;', 'exchange in a commercial or pre-contractual context;', 'follow up received requests;', 'secure the website and limit abusive submissions;', 'measure audience, traffic sources and conversion steps when you have accepted analytics trackers.'],
          },
          {
            title: '4. Legal basis',
            list: ['pre-contractual measures when you request an answer, exchange or commercial proposal;', 'legitimate interest for managing incoming requests, protecting the website and organizing the activity;', 'your consent for analytics trackers that are not strictly necessary. You can withdraw it at any time from Cookie settings.'],
          },
          {
            title: '5. Recipients',
            paragraphs: ['Data is not sold or transferred to third parties for advertising purposes.', 'It may be processed by technical providers strictly necessary for the website operation.'],
            list: ['the website host;', 'the contact form sending service;', 'the email service used to receive and handle requests;', 'Google Analytics, only after consent, for audience and conversion measurement.'],
          },
          {
            title: '6. Retention period',
            paragraphs: ['Messages sent through the form are kept for a reasonable time, limited to what is necessary to process and follow up the request.'],
            list: ['requests without contractual follow-up: maximum retention of 3 years after the last exchange;', 'items linked to a commercial or contractual relationship: kept for the useful duration of the file, then archived if required by law.'],
          },
          {
            title: '7. Cookies and trackers',
            paragraphs: ['Strictly necessary trackers may be used without prior consent. Google Analytics is only loaded after you agree to audience measurement.', 'Your analytics preference is stored locally so the website does not ask on every page. You can change it at any time from Cookie settings.', 'Analytics is used to understand viewed pages, traffic sources and conversion steps. Google Signals and ad personalization are disabled. Some data may be processed outside the EEA under safeguards implemented by the provider.'],
          },
          { title: '8. Security', paragraphs: ['Reasonable measures are taken to protect data against unauthorized access, loss, alteration or unwanted disclosure. No online service can guarantee absolute security.'] },
          {
            title: '9. Your rights',
            paragraphs: ['Under applicable regulations, you have the following rights:'],
            list: ['right of access;', 'right of rectification;', 'right of erasure;', 'right to object;', 'right to restriction of processing;', 'right to define instructions regarding your data after death.'],
            after: ['You can exercise your rights by writing to contact@alioune-seck.dev. If the issue is not resolved, you may file a complaint with the CNIL.'],
          },
          { title: '10. Policy updates', paragraphs: ['This policy may be updated to reflect legal, technical or organizational changes. The update date appears at the top of the page.'] },
        ],
        links: [
          { to: '/mentions-legales', label: 'Legal notice' },
          { to: '/cgu', label: 'Terms' },
        ],
      },
      cgu: {
        kicker: 'Terms of use',
        title: 'Terms of use',
        intro: 'These terms define the rules that apply when browsing alioune-seck.dev.',
        sections: [
          { title: '1. Purpose', paragraphs: ['The website presents the professional activity of Alioune Badara Seck, freelance web developer, along with services, references, projects, presentation content and contact methods.'] },
          { title: '2. Acceptance', paragraphs: ['By browsing the website, the user acknowledges having read and accepted these terms without reservation.'] },
          { title: '3. Access', paragraphs: ['The website is generally accessible 24/7, except for scheduled or unscheduled interruptions such as maintenance, updates, technical incidents or force majeure.', 'The publisher cannot be held liable for temporary unavailability, malfunction or service interruption.'] },
          {
            title: '4. Authorized use',
            paragraphs: ['The user agrees to use the website fairly, lawfully and reasonably. The following are prohibited:'],
            list: ['fraudulent, abusive or malicious use of the contact form;', 'attempted intrusion, degradation or disruption of the website;', 'massive or automated extraction of content without authorization;', 'unlawful reproduction or reuse of texts, visuals or structure elements.'],
          },
          { title: '5. Published content', paragraphs: ['Published content is informational and commercial. It presents an activity, working method, project examples and service offers.', 'Demos, references, code excerpts, interfaces and case studies are illustrative and do not guarantee identical results for every project.'] },
          { title: '6. No automatic contract', paragraphs: ['Simply visiting the website, sending a message or requesting an exchange does not automatically create a contractual relationship.', 'Any assignment is subject, depending on the case, to a quote, written agreement, commercial proposal, contract or explicit validation between the parties.'] },
          { title: '7. Intellectual property', paragraphs: ['All website elements are protected by intellectual property rights of their author or rights holders. Unauthorized reproduction, adaptation, distribution, publication or use is prohibited.'] },
          { title: '8. External links', paragraphs: ['The website may link to external platforms, third-party tools, social networks or partner services. The publisher does not permanently control these external contents and declines responsibility for them.'] },
          { title: '9. Liability', paragraphs: ['The publisher strives to provide reliable and up-to-date information, but does not guarantee absolute completeness, absence of error or suitability for a specific user need.', 'The user remains solely responsible for how they use the information consulted on the website.'] },
          { title: '10. Personal data', paragraphs: ['Using the contact form involves voluntarily sending certain personal data. Its processing is described in the privacy policy.'] },
          { title: '11. Changes to terms', paragraphs: ['These terms may be modified at any time. The applicable version is the one published on the website at the consultation date.'] },
          { title: '12. Applicable law', paragraphs: ['These terms are governed by French law. In case of dispute and without amicable resolution, competent French courts may be seized.'] },
        ],
        links: [
          { to: '/mentions-legales', label: 'Legal notice' },
          { to: '/politique-confidentialite', label: 'Privacy policy' },
        ],
      },
    },
  },
  pt: {
    back: '← Voltar ao site',
    langLabel: 'Idioma',
    updated: 'Última atualização: 8 de outubro de 2026',
    brandRole: 'Documentos legais',
    legalNav: 'Navegação legal',
    pages: {
      mentions: {
        kicker: 'Informações legais',
        title: 'Aviso legal',
        intro:
          'Este aviso identifica o editor do site alioune-seck.dev, sua atividade e hospedagem.',
        sections: [
          {
            title: 'Editor do site',
            definitions: [
              ['Nome', 'Alioune Badara Seck'],
              ['Forma jurídica', 'Empreendedor individual'],
              ['SIREN', '995 288 438'],
              ['SIRET', '995 288 438 00014'],
              ['Código APE', '62.01Z - Programação informática'],
              ['Endereço', '1 place Guy Ropartz, 29000 Quimper, França'],
              ['Email', 'contact@alioune-seck.dev'],
              ['Telefone', '+33 7 84 28 23 93'],
              ['Atividade', 'Desenvolvimento de aplicações web, frontend/backend, ferramentas de negócio, MVPs, integrações API e apoio técnico.'],
            ],
          },
          { title: 'Diretor de publicação', paragraphs: ['O diretor de publicação do site é Alioune Badara Seck.'] },
          {
            title: 'Hospedagem',
            definitions: [
              ['Fornecedor', 'Vercel Inc.'],
              ['Endereço', '440 N Barranca Avenue #4133, Covina, CA 91723, Estados Unidos'],
              ['Telefone', '+1 559 288 7060'],
              ['Site', 'vercel.com'],
            ],
          },
          {
            title: 'Propriedade intelectual',
            paragraphs: [
              'Textos, elementos gráficos, layouts, estruturas, componentes, logos, ícones, trechos de código, estudos de caso e conteúdos editoriais são protegidos por direitos autorais e propriedade intelectual.',
              'Salvo menção contrária, esses elementos pertencem exclusivamente a Alioune Badara Seck. Qualquer reprodução, adaptação, difusão ou uso sem autorização escrita prévia é proibido.',
            ],
          },
          {
            title: 'Responsabilidade',
            paragraphs: [
              'O site apresenta uma atividade profissional, referências, ofertas de serviço e meios de contato. As informações são indicativas e podem ser modificadas a qualquer momento.',
              'Apesar do cuidado com o conteúdo, o editor não pode garantir ausência total de erros, omissões ou indisponibilidades pontuais.',
            ],
          },
          { title: 'Links externos', paragraphs: ['O site pode conter links para sites terceiros. O editor não é responsável por seu conteúdo, política de privacidade ou funcionamento.'] },
          { title: 'Dados pessoais', paragraphs: ['As informações enviadas pelo formulário de contato são tratadas apenas no âmbito de trocas profissionais. A política de privacidade detalha os dados coletados, seu uso e seus direitos.'] },
          { title: 'Lei aplicável', paragraphs: ['O site está sujeito ao direito francês. Em caso de litígio e sem resolução amigável, os tribunais franceses competentes poderão ser acionados.'] },
        ],
        links: [
          { to: '/cgu', label: 'Termos de uso' },
          { to: '/politique-confidentialite', label: 'Política de privacidade' },
        ],
      },
      privacy: {
        kicker: 'Dados pessoais',
        title: 'Política de privacidade',
        intro:
          'Esta política explica quais dados podem ser coletados, por que são coletados, por quanto tempo são conservados e quais são seus direitos.',
        sections: [
          { title: '1. Responsável pelo tratamento', paragraphs: ['O responsável pelo tratamento dos dados é Alioune Badara Seck, empreendedor individual, contactável em contact@alioune-seck.dev.'] },
          {
            title: '2. Dados coletados',
            paragraphs: ['Ao usar o formulário de contato, os seguintes dados podem ser coletados:'],
            list: ['seu nome;', 'seu endereço de email;', 'o conteúdo da mensagem;', 'dados técnicos mínimos ligados ao envio do formulário e à segurança do site.'],
            after: ['O site não tem como finalidade coletar dados sensíveis. Não envie informações confidenciais desnecessárias.'],
          },
          {
            title: '3. Finalidades',
            paragraphs: ['Os dados coletados são usados apenas para:'],
            list: ['responder a um contato ou pedido de orçamento;', 'trocar informações em contexto comercial ou pré-contratual;', 'acompanhar os pedidos recebidos;', 'proteger o site e limitar envios abusivos;', 'medir audiência, fontes de tráfego e etapas de conversão quando você aceitou os rastreadores de medição.'],
          },
          { title: '4. Base legal', list: ['medidas pré-contratuais quando você solicita uma resposta, troca ou proposta comercial;', 'interesse legítimo para gerir pedidos, proteger o site e organizar a atividade;', 'seu consentimento para rastreadores de audiência não estritamente necessários. Você pode retirá-lo a qualquer momento em Gerir cookies.'] },
          {
            title: '5. Destinatários',
            paragraphs: ['Os dados não são vendidos nem cedidos a terceiros para fins publicitários.', 'Podem ser tratados por prestadores técnicos estritamente necessários ao funcionamento do site.'],
            list: ['hospedagem do site;', 'serviço de envio do formulário;', 'mensageria usada para receber e tratar pedidos;', 'Google Analytics, somente após consentimento, para medição de audiência e conversões.'],
          },
          {
            title: '6. Prazo de conservação',
            paragraphs: ['Mensagens enviadas pelo formulário são conservadas por um prazo razoável, limitado ao necessário para tratar e acompanhar o pedido.'],
            list: ['pedidos sem seguimento contratual: conservação máxima de 3 anos após a última troca;', 'elementos ligados a uma relação comercial ou contratual: conservação pelo prazo útil do dossiê, depois arquivamento se a lei exigir.'],
          },
          { title: '7. Cookies e rastreadores', paragraphs: ['Rastreadores estritamente necessários podem ser usados sem consentimento prévio. O Google Analytics só é carregado depois que você aceita a medição de audiência.', 'Sua preferência de medição é guardada localmente para não ser solicitada em cada página. Ela pode ser alterada a qualquer momento em Gerir cookies.', 'A medição serve para compreender páginas visitadas, fontes de tráfego e etapas de conversão. Google Signals e personalização publicitária ficam desativados. Alguns dados podem ser processados fora do EEE de acordo com as garantias implementadas pelo prestador.'] },
          { title: '8. Segurança', paragraphs: ['Medidas razoáveis são tomadas para proteger os dados contra acesso não autorizado, perda, alteração ou divulgação indesejada. Nenhum serviço online pode garantir segurança absoluta.'] },
          {
            title: '9. Seus direitos',
            paragraphs: ['De acordo com a regulamentação aplicável, você dispõe dos seguintes direitos:'],
            list: ['direito de acesso;', 'direito de retificação;', 'direito de apagamento;', 'direito de oposição;', 'direito à limitação do tratamento;', 'direito de definir instruções sobre seus dados após falecimento.'],
            after: ['Você pode exercer seus direitos escrevendo para contact@alioune-seck.dev. Em caso de dificuldade não resolvida, é possível apresentar reclamação à CNIL.'],
          },
          { title: '10. Atualização da política', paragraphs: ['Esta política pode ser atualizada para refletir mudanças legais, técnicas ou organizacionais. A data de atualização aparece no topo da página.'] },
        ],
        links: [
          { to: '/mentions-legales', label: 'Aviso legal' },
          { to: '/cgu', label: 'Termos' },
        ],
      },
      cgu: {
        kicker: 'Termos de uso',
        title: 'Condições gerais de uso',
        intro: 'Estas condições definem as regras aplicáveis à navegação no site alioune-seck.dev.',
        sections: [
          { title: '1. Objeto do site', paragraphs: ['O site apresenta a atividade profissional de Alioune Badara Seck, desenvolvedor web independente, bem como serviços, referências, realizações, conteúdos de apresentação e meios de contato.'] },
          { title: '2. Aceitação', paragraphs: ['Ao navegar no site, o usuário reconhece ter lido e aceitado estas condições sem reserva.'] },
          { title: '3. Acesso ao site', paragraphs: ['O site é em princípio acessível 24h/24 e 7d/7, salvo interrupção programada ou não, incluindo manutenção, atualização, incidente técnico ou força maior.', 'O editor não pode ser responsabilizado por indisponibilidade temporária, mau funcionamento ou interrupção de serviço.'] },
          {
            title: '4. Uso autorizado',
            paragraphs: ['O usuário compromete-se a usar o site de forma leal, lícita e razoável. São proibidos:'],
            list: ['uso fraudulento, abusivo ou malicioso do formulário de contato;', 'tentativa de intrusão, degradação ou perturbação do site;', 'extração massiva ou automatizada dos conteúdos sem autorização;', 'reprodução ou reutilização ilícita dos textos, visuais ou elementos de estrutura.'],
          },
          { title: '5. Conteúdos publicados', paragraphs: ['Os conteúdos publicados têm finalidade informativa e comercial. Apresentam uma atividade, método de trabalho, exemplos de projetos e ofertas de serviço.', 'Demonstrações, referências, trechos de código, interfaces e estudos de caso são ilustrativos e não constituem garantia de resultado idêntico para todos os projetos.'] },
          { title: '6. Ausência de relação contratual automática', paragraphs: ['Visitar o site, enviar uma mensagem ou pedir uma troca não cria automaticamente uma relação contratual.', 'Toda missão é objeto, conforme o caso, de orçamento, acordo escrito, proposta comercial, contrato ou validação explícita entre as partes.'] },
          { title: '7. Propriedade intelectual', paragraphs: ['Todos os elementos do site são protegidos por direitos de propriedade intelectual de seu autor ou titulares. Reprodução, adaptação, difusão, publicação ou exploração não autorizada é proibida.'] },
          { title: '8. Links externos', paragraphs: ['O site pode encaminhar para plataformas externas, ferramentas terceiras, redes sociais ou serviços parceiros. O editor não controla permanentemente esses conteúdos e declina responsabilidade sobre eles.'] },
          { title: '9. Responsabilidade', paragraphs: ['O editor esforça-se para fornecer informações confiáveis e atualizadas, mas não garante completude absoluta, ausência de erro ou adequação a uma necessidade específica.', 'O usuário permanece responsável pelo uso das informações consultadas no site.'] },
          { title: '10. Dados pessoais', paragraphs: ['O uso do formulário de contato implica o envio voluntário de certos dados pessoais. Seu tratamento é descrito na política de privacidade.'] },
          { title: '11. Alteração dos termos', paragraphs: ['Estas condições podem ser modificadas a qualquer momento. A versão aplicável é a publicada no site na data de consulta.'] },
          { title: '12. Lei aplicável', paragraphs: ['Estas condições são submetidas ao direito francês. Em caso de litígio e sem resolução amigável, os tribunais franceses competentes poderão ser acionados.'] },
        ],
        links: [
          { to: '/mentions-legales', label: 'Aviso legal' },
          { to: '/politique-confidentialite', label: 'Política de privacidade' },
        ],
      },
    },
  },
};
